import { createContext } from 'react';
import { IProxyContext } from './types/context-types';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const ProxyContext = createContext<IProxyContext>(null!);

export default ProxyContext;
